import { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { authAPI } from "../lib/api";
import { Archive, Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmailPage({ token, onDone }) {
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authAPI.verifyEmail(token);
        if (cancelled) return;
        if (res.data?.token && res.data?.user) {
          localStorage.setItem("archiva_token", res.data.token);
          localStorage.setItem("archiva_user", JSON.stringify(res.data.user));
        }
        setStatus("success");
      } catch (err) {
        if (cancelled) return;
        setMessage(err.response?.data?.detail || "Verification failed.");
        setStatus("error");
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md fade-in">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-primary flex items-center justify-center">
              <Archive className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-4xl font-bold tracking-tight">Archiva</h1>
          </div>
        </div>
        <Card className="border border-border shadow-none">
          <CardContent className="pt-8 pb-6 text-center space-y-4">
            {status === "verifying" && (
              <>
                <Loader2 className="w-10 h-10 mx-auto animate-spin text-primary" />
                <p className="text-sm text-muted-foreground">Verifying your email…</p>
              </>
            )}
            {status === "success" && (
              <>
                <div className="w-14 h-14 mx-auto rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircle2 className="w-7 h-7 text-green-600" />
                </div>
                <h2 className="text-xl font-semibold">Email verified</h2>
                <p className="text-sm text-muted-foreground">
                  You're all set. You're now signed in.
                </p>
                <Button className="w-full" onClick={onDone}>
                  Continue to Archiva
                </Button>
              </>
            )}
            {status === "error" && (
              <>
                <div className="w-14 h-14 mx-auto rounded-full bg-red-100 flex items-center justify-center">
                  <XCircle className="w-7 h-7 text-red-600" />
                </div>
                <h2 className="text-xl font-semibold">Verification failed</h2>
                <p className="text-sm text-muted-foreground">{message}</p>
                <Button variant="outline" className="w-full" onClick={onDone}>
                  Back to sign in
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
